import React, { useRef } from "react";
import "./App.css";
import "./assets/styles/Reset.css";
import Autores from "./components/autores/Autores.js";
import Bonus from "./components/bonus/Bonus.js";
import CtaFinal from "./components/ctaFinal/CtaFinal.js";
import Depoimentos from "./components/depoimentos/Depoimentos.js";
import Etapas from "./components/etapas/Etapas.js";
import FAQ from "./components/fAQ/FAQ.js";
import Garantia from "./components/garantia/Garantia.js";
import Hero from "./components/hero/Hero.js";
import ListaToggle from "./components/oQueVoceAprendera/ListaToggle.js";
import OQueVoceAprendera from "./components/oQueVoceAprendera/OQueVoceAprendera.js";
import PorDentroDaPlataforma from "./components/porDentroDaPlataforma/PorDentroDaPlataforma.js";
import PraQuemFoiEscrito from "./components/praQuemFoiEscrito/PraQuemFoiEscrito.js";
import Valores from "./components/valores/Valores.js";

function App() {
  const main = process.env.REACT_APP_MAIN;

  const ValorRef = useRef();

  const scrollToComponent = () => {
    if (ValorRef.current) {
      const yOffset = 60;
      const yCoordinate =
        ValorRef.current.getBoundingClientRect().top +
        window.scrollY +
        yOffset;
      window.scrollTo({ top: yCoordinate, behavior: 'smooth' });
    }
  };
  return (
    <div className="App">
      <Hero onScroll={scrollToComponent} />
      <Etapas />
      <Depoimentos onScroll={scrollToComponent} />
      <PraQuemFoiEscrito />
      <OQueVoceAprendera onScroll={scrollToComponent} />
      <PorDentroDaPlataforma onScroll={scrollToComponent} />
      <Bonus />
      <div ref={ValorRef}>
        <Valores />
      </div>
      <Garantia />
      <Autores />
      <FAQ onScroll={scrollToComponent} />
      <CtaFinal />
    </div>
  );
}

export default App;
